/* Intestazione: link testuali a sinistra e destra, come l'originale */
(function () {
  function place() {
    const tpl = document.getElementById('SmHeaderLinks');
    const header = document.querySelector('header.header');
    if (!tpl || !header || header.querySelector('.sm-hlinks')) return;
    const frag = tpl.content.cloneNode(true);
    const left = frag.querySelector('.sm-hlinks--left');
    const right = frag.querySelector('.sm-hlinks--right');
    if (left && left.children.length) header.appendChild(left);
    const icons = header.querySelector('.header__icons');
    if (right && right.children.length && icons) icons.prepend(right);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place);
  else place();
})();

/* Titolo della pagina "tutti i prodotti" (generato da Shopify nella lingua del negozio) */
(function () {
  const fix = () => {
    if (!/\/collections\/all\/?$/.test(location.pathname)) return;
    document.querySelectorAll('.collection-hero__title').forEach((h) => {
      const t = h.textContent.trim().toLowerCase();
      if (t === 'produits' || t === 'products' || t === 'prodotti' || t.endsWith('produits')) h.textContent = 'Tutti i prodotti';
    });
    if (/^Produits/i.test(document.title)) document.title = document.title.replace(/^Produits/i, 'Tutti i prodotti');
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix);
  else fix();
})();

/* Ordinamento: opzione "most-relevant" tradotta */
(function () {
  const fix = () => {
    document.querySelectorAll('select option[value="most-relevant"]').forEach((o) => { if (o.textContent !== 'Più pertinenti') o.textContent = 'Più pertinenti'; });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix);
  else fix();
  document.addEventListener('shopify:section:load', fix);
  const grid = document.getElementById('ProductGridContainer') || document.querySelector('.facets-container, main');
  if (grid) new MutationObserver(fix).observe(grid, { childList: true, subtree: true });
})();
